import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import componentParser from "AtomicUtils/componentParser"
import { noop } from "utils"
import { HeadingBlock } from "containers"
import { GlobalNavItemGrid, NameplateLink } from "components"
import { Section, Content } from "AtomicComponents"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

const SelectNameplate = ({
  onNameplateChange = noop,
  nameplateStock = [],
  preHeading = "",
  heading = "",
  description = "",
  components = [],
  noStockError
}) => (
  <div>
    {componentParser(components)}
    <Section verticalPadding backgroundColor="#F5F5F5">
      <HeadingBlock margin={false} textAlign={"center"} preHeading={preHeading} value={heading} />
      {description && (
        <Content xmlString={description} />
      )}
      {noStockError && (
        <p style={{ color: "red", lineHeight: "1.5em", marginTop: "2em" }}>{noStockError}</p>
      )}
      <GlobalNavItemGrid fadeItems={false}>
        {nameplateStock.map(({
          nameplate,
          imageSrcSide,
          unavailableCta,
          gtmEvents,
          inStock
        }, index) => (
          <NameplateLink
            key={index}
            type={
              inStock ? (
                <span>Available</span>
              ) : (
                <span>
                  No Outlet stock available.{" "}
                    <span className={classnames({
                      [typographyStyles.A]: true
                    })}>{unavailableCta.label}</span>
                </span>
              )
            }
            appearDisabled={!inStock}
            image={imageSrcSide}
            name={nameplate}
            href={!inStock ? unavailableCta.href : null}
            gtmEvents={gtmEvents || []}
            onClick={() => inStock && onNameplateChange({ nameplate })} />
        ))}
      </GlobalNavItemGrid>
    </Section>
  </div>
)

SelectNameplate.propTypes = {
  preHeading: PropTypes.string,
  heading: PropTypes.string,
  components: PropTypes.array,
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  nameplateStock: PropTypes.array,
  onNameplateChange: PropTypes.func,
  noStockError: PropTypes.element
}

export default SelectNameplate



// WEBPACK FOOTER //
// ./src/containers/outlet-store/select-nameplate.jsx